import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'
import DownloadPdf from 'wt-react/dist/components/DownloadPdf/DownloadPdf'
import { connect } from 'react-redux'
import i18n from './../../../i18n'
import './FactSheetDownload.css'


class FactSheetDownload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPdfModal: false,
    };
  }

  toggleShowPdfModal = () => {
    this.setState(prevState => ({
      showPdfModal: !prevState.showPdfModal,
    }));
  };

  render() {
    const { token, clientEmail } = this.props;

    if (!this.props.strategyType) {
      return null
    }

    return (
      


        <div class='download-pdf-container'>
  

            <DownloadPdf
              token={token}
              clientEmail={clientEmail}
              configId={'6570d95113bea9122e555a27'}
              initialButtonText={'Factsheet'}
              modalTitleText={'test'}
              waitingMessageText={'waiting...'}
              dataspanApiUrl={'https://dataspanapidev.wisdomtree.com'}
              dpdApiUrl={'https://dpddev.wisdomtree.com'}
              openModalOnLoad={false}
              submitOnLoad={false}
              callbackOnClose={null}
              adhocInputs={[
                {
                  name: 'entityID',
                  type: 'string',
                  value: 'SIEGEA',
                  label: 'Siegel-WisdomTree Global Equity Model',
                },
              ]}
            />
   
   </div>

    );
  }
}

// Map state to props using connect
const mapStateToProps = state => ({
  token: state.params.token,
  clientEmail: state.params.clientEmail,
});

export default connect(mapStateToProps)(FactSheetDownload);
